import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { Text } from "react-native";
import { useTheme } from "react-native-paper";
import { Box, type IconType, useBreakpoints } from "../..";

type Props = {
	icon: IconType;
	title: string;
	subtitle: string;
};

const FeatureListItem = ({ icon, title, subtitle }: Props) => {
	const theme = useTheme();
	const { smUp: isTabletUp, smDown: isMobileDown } = useBreakpoints();

	return (
		<Box
			style={{
				flexDirection: isTabletUp ? "column" : "row",
				alignItems: isTabletUp ? "center" : "flex-start",
				gap: 12,
				flex: 1,
			}}
		>
			<Icon
				name={icon}
				size={20}
				color={theme.colors.onPrimary}
				style={{
					backgroundColor: theme.colors.inversePrimary,
					padding: 6,
					marginTop: isMobileDown ? 7 : 0,
				}}
			/>
			<Box
				style={{
					flex: 1,
					alignItems: isTabletUp ? "center" : "flex-start",
					flexWrap: "wrap",
				}}
			>
				<Text
					style={{
						fontSize: 14,
						fontWeight: "600",
						lineHeight: 24,
					}}
				>
					{title}
				</Text>
				<Text
					style={{
						fontSize: 14,
						color: theme.colors.onSurfaceVariant,
						lineHeight: 24,
						textAlign: isTabletUp ? "center" : "left",
					}}
				>
					{subtitle}
				</Text>
			</Box>
		</Box>
	);
};

export default FeatureListItem;
